import buildVariables from "./buildVariables";
import buildGqlQuery from "./buildGqlQuery";
import getResponseParser from "./getResponseParser";
import { GET_LIST, GET_ONE, GET_MANY, GET_MANY_REFERENCE } from "react-admin";
var MANY_FETCH_TYPES = [GET_LIST, GET_MANY, GET_MANY_REFERENCE];
export var buildQueryFactory = function (introspectionResults, _a) {
    var _b = _a === void 0 ? {} : _a, resourceViews = _b.resourceViews;
    var knownResources = introspectionResults.resources.map(function (r) { return r.type.name; });
    return function (aorFetchType, resourceName, params) {
        var resourceView = resourceViews === null || resourceViews === void 0 ? void 0 : resourceViews[resourceName];
        var isResourceView = Boolean(resourceView);
        var resourceNameToUse = isResourceView
            ? resourceView.resource
            : resourceName;
        var resource = introspectionResults.resources.find(function (r) { return r.type.name === resourceNameToUse; });
        if (!resource) {
            throw new Error("Unknown resource " + resourceNameToUse + ". Make sure it has been declared on your server side schema. Known resources are " + knownResources.join(", ") + ". " + (resourceViews
                ? "Known view resources are " + Object.keys(resourceViews).join(", ")
                : ""));
        }
        var fragment = undefined;
        if (resourceView) {
            // type union info is lost after compiling to JS
            // however, we can check for existence of "one" or "many" fields in the fragment which would indicate DoubleFragment type
            var maybeDoubleFragment = resourceView.fragment;
            if (maybeDoubleFragment.one && maybeDoubleFragment.many) {
                var fragmentObject = resourceView.fragment;
                if (MANY_FETCH_TYPES.indexOf(aorFetchType) !== -1) {
                    fragment = fragmentObject.many;
                }
                else if (aorFetchType === GET_ONE) {
                    fragment = fragmentObject.one;
                }
            }
            else if (!maybeDoubleFragment.one && !maybeDoubleFragment.many) {
                fragment = resourceView.fragment;
            }
            else {
                throw new Error("Error in resource view " + resourceName + " - you either must specify both 'one' and 'many' fragments or use a single fragment for both.");
            }
        }
        var variables = buildVariables(introspectionResults)(resource, aorFetchType, params);
        var query = buildGqlQuery(introspectionResults)(resource, aorFetchType, variables, fragment);
        var parseResponse = getResponseParser(introspectionResults, {
            shouldSanitizeLinkedResources: !isResourceView,
        })(aorFetchType, resource);
        return {
            query: query,
            variables: variables,
            parseResponse: parseResponse,
        };
    };
};
//# sourceMappingURL=buildQuery.js.map